<script lang="ts">
  import ButtonLink from "../button-link/ButtonLink.svelte";
  import ArrowIcon from "../../../../images/chevron-left.svg";

  export let onClick: (...args: unknown[]) => unknown;
</script>

<ButtonLink icon={ArrowIcon} {onClick} text="Back" />
